import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetPaymentMethodsQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
}>;


export type GetPaymentMethodsQuery = { __typename?: 'query_root', arpaymentmethods: Array<{ __typename?: 'arpaymentmethods', id: number, customer_id: number, gateway_token: string, active: boolean, primary: boolean, account_type?: string | null, account_number: number, name: string, type: string, card_type?: string | null, expiration?: number | null, routing_number?: number | null, source: string, gateway: string, bank_name: string }> };


export const GetPaymentMethodsDocument = gql`
    query getPaymentMethods($customerId: bigint!) {
  arpaymentmethods(
    where: {customer_id: {_eq: $customerId}, active: {_eq: true}, type: {_neq: "manual"}, pending_setup_intent_id: {_is_null: true}}
    order_by: {primary: desc, name: asc}
  ) {
    id
    customer_id
    gateway_token
    active
    primary
    account_type
    account_number
    name
    type
    card_type
    expiration
    routing_number
    source
    gateway
    bank_name
  }
}
    `;

/**
 * __useGetPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetPaymentMethodsQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables> & ({ variables: GetPaymentMethodsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>(GetPaymentMethodsDocument, options);
      }
export function useGetPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>(GetPaymentMethodsDocument, options);
        }
// @ts-ignore
export function useGetPaymentMethodsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>;
export function useGetPaymentMethodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentMethodsQuery | undefined, GetPaymentMethodsQueryVariables>;
export function useGetPaymentMethodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>(GetPaymentMethodsDocument, options);
        }
export type GetPaymentMethodsQueryHookResult = ReturnType<typeof useGetPaymentMethodsQuery>;
export type GetPaymentMethodsLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodsLazyQuery>;
export type GetPaymentMethodsSuspenseQueryHookResult = ReturnType<typeof useGetPaymentMethodsSuspenseQuery>;
export type GetPaymentMethodsQueryResult = Apollo.QueryResult<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/invoices/queries/getPaymentMethods.query.gql}
 */
export async function getPaymentMethods(
  variables: GetPaymentMethodsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetPaymentMethodsQuery['arpaymentmethods']>
export async function getPaymentMethods(
  variables: GetPaymentMethodsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetPaymentMethodsQuery>
export async function getPaymentMethods(
  variables: GetPaymentMethodsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetPaymentMethodsQuery['arpaymentmethods'] | GetPaymentMethodsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetPaymentMethodsQuery>(
    GetPaymentMethodsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.arpaymentmethods
}